module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-292.87d10c3.woff2";